<template>
  <div class="page full">
    <div id="public-web-container" class="hidden">
      <p class="title">正在打开 “网上照明展”...</p>
      <a
        id="public-web-jump-button"
        href="javascript:"
        class="weui-btn weui-btn_primary weui-btn_loading"
        @click="openWeapp()"
      >
        <span
          id="public-web-jump-button-loading"
          class="weui-primary-loading weui-primary-loading_transparent"
          ><i class="weui-primary-loading__dot"></i
        ></span>
        打开小程序
      </a>
    </div>

    <div id="wechat-web-container" class="hidden">
      <p class="title">点击以下按钮打开 “网上照明展”</p>
      <!-- 跳转小程序的开放标签。文档 https://developers.weixin.qq.com/doc/offiaccount/OA_Web_Apps/Wechat_Open_Tag.html -->
      <wx-open-launch-weapp
        id="launch-btn"
        username="gh_bd069c310855"
        :path="path"
      >
        <script type="text/wxtag-template">
          <style>.btn {width: 200px;height: 45px;text-align: center;font-size: 17px;display: block;margin: 0 auto;padding: 8px 24px;border: none;border-radius: 4px;background-color: #07c160;color: #fff;}</style>
          <button class="btn">打开小程序</button>
        </script>
      </wx-open-launch-weapp>
    </div>
  </div>
</template>
<script>
import { generateScheme } from "@/api/index";
export default {
  name: "middleware",
  data() {
    return {
      path: ""
    };
  },
  methods: {
    //微信浏览器
    docReady() {
      var that = this;
      var ua = navigator.userAgent.toLowerCase();
      var isWXWork = ua.match(/wxwork/i) == "wxwork";
      var isWeixin =
        !isWXWork && ua.match(/micromessenger/i) == "micromessenger";
      // var isMobile = false;
      // if (
      //   navigator.userAgent.match(
      //     /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|IEMobile)/i
      //   )
      // ) {
      //   isMobile = true;
      // }
      if (isWeixin) {
        var containerEl = document.getElementById("wechat-web-container");
        containerEl.classList.remove("hidden");
        containerEl.classList.add("full", "wechat-web-container");

        var launchBtn = document.getElementById("launch-btn");
        launchBtn.addEventListener("ready", function (e) {
          console.log("开放标签 ready");
        });
        launchBtn.addEventListener("launch", function (e) {
          console.log("开放标签 success");
        });
        launchBtn.addEventListener("error", function (e) {
          console.log("开放标签 fail", e.detail);
        });
      } else {
        var containerEl = document.getElementById("public-web-container");
        containerEl.classList.remove("hidden");
        containerEl.classList.add("full", "public-web-container");
        var buttonEl = document.getElementById("public-web-jump-button");
        var buttonLoadingEl = document.getElementById(
          "public-web-jump-button-loading"
        );
        try {
          that.openWeapp(() => {
            buttonEl.classList.remove("weui-btn_loading");
            buttonLoadingEl.classList.add("hidden");
          });
        } catch (e) {
          buttonEl.classList.remove("weui-btn_loading");
          buttonLoadingEl.classList.add("hidden");
          throw e;
        }
      }
    },

    //除微信浏览器
    async openWeapp() {
      var that = this;
      var ua = navigator.userAgent.toLowerCase();
      var isWXWork = ua.match(/wxwork/i) == "wxwork";
      var isWeixin =
        !isWXWork && ua.match(/micromessenger/i) == "micromessenger";
      if (!isWeixin) {
        const res = await generateScheme({
          Path: that.path,
        });
        location.href = res.Data;
      }
    },
  },
  mounted() {
    this.path = decodeURIComponent(this.$route.query.path);
    this.docReady();
  },
};
</script>
<style scope>
.title {
  font-size: 16px;
}
.hidden {
  display: none;
}

.full {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}

.public-web-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.public-web-container p {
  position: absolute;
  top: 40%;
}

.public-web-container a {
  position: absolute;
  bottom: 40%;
}

.wechat-web-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.wechat-web-container p {
  position: absolute;
  top: 40%;
}

.wechat-web-container wx-open-launch-weapp {
  position: absolute;
  bottom: 40%;
  left: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>